import { render, staticRenderFns } from "./FormInput2.vue?vue&type=template&id=7de5f77f"
import script from "./FormInput2.vue?vue&type=script&lang=ts"
export * from "./FormInput2.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports